/**
 * Date formatting helpers for CardBody component
 * Contains functions for formatting dates consistently
 */

import moment from "moment-timezone";

/**
 * Format end time to standard format for lock hours checking
 * @param {string|Date} endTime - End time to format
 * @param {Object} globalConfig - Global config object with getTimeZone method
 * @returns {string} Formatted date string
 */
export const formatEndTimeForLockCheck = (endTime, globalConfig) => {
  return moment(endTime)
    .tz(globalConfig.getTimeZone())
    .format("YYYY-MM-DD HH:mm:ss");
};

/**
 * Check if entry is locked using formatted end time
 * @param {string|Date} endTime - End time to check
 * @param {Object} globalConfig - Global config object
 * @param {Function} getLockHoursHandler - Lock hours handler function
 * @returns {boolean} True if unlocked, false if locked
 */
export const isEntryUnlocked = (endTime, globalConfig, getLockHoursHandler) => {
  const formattedDate = formatEndTimeForLockCheck(endTime, globalConfig);
  return getLockHoursHandler(
    formattedDate,
    globalConfig.getTimeZone(),
    "YYYY-MM-DD HH:mm:ss"
  ) === true;
};
